import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { CommonUtil } from '../utils';

/**
 * [Model] ProjectItem
 */
var ProjectItem = /*#__PURE__*/function () {
  function ProjectItem() {
    _classCallCheck(this, ProjectItem);
  }
  return _createClass(ProjectItem, null, [{
    key: "parseV1",
    value:
    /**
     * Parse snake case data
     */
    function parseV1(data) {
      var rowData = data || {};
      var project = new ProjectItem();
      project.id = rowData.ea_project_id || rowData.id;
      project.name = rowData.name;
      project.title = rowData.title;
      project.status = rowData.status;
      project.scopes = rowData.scopes;
      project.accountStatus = {
        category: CommonUtil.getValue(rowData, 'account_status.category'),
        priceModel: CommonUtil.getValue(rowData, 'account_status.price_model')
      };
      project.accountId = rowData.account_id;
      project.accountName = rowData.account_display_name;
      project.containers = [{
        id: rowData.issue_container_id,
        type: 'issue'
      }, {
        id: rowData.markup_container_id,
        type: 'markup'
      }, {
        id: rowData.rfi_container_id,
        type: 'rfi'
      }, {
        id: rowData.cost_container_id,
        type: 'cost'
      }];
      project.copyInfo = rowData.copy_info || {};
      project.wipnextInfo = rowData.wipnext_info || {};
      project.copyWorkflowInfo = rowData.copy_workflow_info || {};
      project.showFileSize = rowData.show_file_size;
      project.showFileActivity = rowData.show_file_activity;
      project.publicLinkEnabled = rowData.public_link_enabled;
      project.publicLinkExpiration = rowData.public_link_expiration;
      project.folderFullPathEnabled = rowData.folder_full_path_enabled;
      project.uploaderEditAttributeValuesEnabled = rowData.uploader_edit_attribute_values_enabled;
      project.vectorPdfViewingEnabled = rowData.vector_pdf_viewing_enabled;
      project.distributedFolderUrn = rowData.distributed_folder_urn;
      project.normalFolderUrn = rowData.normal_folder_urn;
      project.namingStandardEnabled = rowData.naming_standard_enabled;
      project.rootUrn = rowData.root_urn;
      return project;
    }
  }]);
}();
export { ProjectItem as default };